import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography } from '@mui/material'
import InputSearchMap from 'Components/Map/components/InputSearchMap';
import { Alert } from '@mui/material';
import { getGeocoder } from 'Components/Map/providers/googleGeocoder'
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';
import { Button, Input, Form } from 'Components';
import { useIntl } from 'react-intl';
// import TagFilter from 'Modules/.common/components/TagFilter';
import './style.scss';

import {
  openModalEditImportLandmark,
  mapLandmarksEditCreateLandmark,
  clearRedux
} from 'Redux/actions';


const LandmarkImportEdit = (props) => {
  const { callBack } = props;
  const dispatch = useDispatch();
  const { messages } = useIntl();
  const editCreateLandmark = useRef();
  const [formData, setFormData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState("");
  const [valueMap, setValueMap] = useState('');
  const {
    openImportEditModal,
    landmarkEdit
  } = useSelector((state) => state.realtimeMapLandmarkImportModuleRedux);

  const { landmarkTags } = useSelector((state) => state.realtimeMapLandmarkListModuleRedux);
  const {
    response,
    loadingResponse
  } = useSelector((state) => state.realtimeMapLandmarkCreateEditModuleRedux);

  useEffect(() => {
    if (response) {
      if (response.error) {
        NotificationManager.error(
          response.message || messages['errorMessage'],
          messages['error'],
          3000,
          null,
          null,
          'warning',
        );
      } else {
        NotificationManager.success(
          messages['mapLandmarkCreateEditLandmark_success'],
          messages['success'],
          3000,
          null,
          null,
          'success',
        );
        callBack(landmarkEdit);
        handleClose();
      }
    }
  }, [response]);


  useEffect(() => {
    setError(landmarkEdit?.error)
    if (landmarkEdit?.Name) {
      let Tags = [];
      if (landmarkTags.length > 0 && landmarkEdit?.Tags) {
        Tags = landmarkTags.filter(d => landmarkEdit?.Tags.includes(d?.label));
      }

      if (landmarkEdit?.Latitude && landmarkEdit?.Longitude && !isNaN(landmarkEdit?.Latitude) && !isNaN(landmarkEdit?.Longitude)) {
        getGeocoder({
          from: 'latlng',
          lat: landmarkEdit?.Latitude,
          lng: landmarkEdit?.Longitude,
          callback: (value) => {
            if (value && value.result == true) {
              const { data } = value
              setValueMap(data[0].fulladdress)
            }
          }
        })
      } else if (landmarkEdit?.Address) {
        setValueMap(landmarkEdit?.Address)
      }



      setFormData({
        ...landmarkEdit,
        Tags
      })

    }
  }, [landmarkEdit]);


  const handleClose = useCallback(() => {
    setValueMap('');
    setFormData({});
    setErrorMessage("");
    dispatch(openModalEditImportLandmark(false, {}))
  });

  const onSubmit = () => {

    if (!formData?.Tags?.length || !formData?.Name || !formData?.address?.lat || !formData?.Radius) {
      setErrorMessage(messages['settingsTemperature_complete_fields'])
      return false;
    }

    let tagsIds = formData?.Tags.map((item) => item.id)
    dispatch(mapLandmarksEditCreateLandmark({
      color: "8677D9",
      iconName: "",
      radius: formData?.Radius,
      name: formData?.Name,
      note: formData?.Note,
      tagsIds,
      latitude: formData?.address?.lat,
      longitude: formData?.address?.lng,
      shape: "circle",
      coordinates: [
        {
          latitude: formData?.address?.lat,
          longitude: formData?.address?.lng
        }
      ],
      address: formData?.address?.fulladdress,
      city: formData?.address?.city,
      zip: formData?.address?.postalcode,
      state: formData?.address?.state,
      country: formData?.address?.country
    }));

  }

  return (
    <Modal
      title={landmarkEdit?.Name}
      open={openImportEditModal}
      position="right"
      size="small"
      className="modal-top-0"
      headerStyle={{
        top: 0
      }}
      handleClose={handleClose}
      hiddenCloseButton
      iconBackClose
    >
      <ModalBody>
        {errorMessage &&
          <Alert severity="error" onClose={() => { setErrorMessage("") }}>{errorMessage}</Alert>
        }
        <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>
          <Form ref={editCreateLandmark}
            onValidSubmit={onSubmit}
            className="formImportLandmark">
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={0}
              style={{ marginTop: 5 }}
            >
              <Grid item xs={12}>
                <Input
                  id="name"
                  type="text"
                  label={messages['mapLandmarkCreateEditLandmark_landmarkName']}
                  placeholder={messages['mapLandmarkCreateEditLandmark_landmarkName']}
                  value={formData.Name}
                  onChange={(value) => setFormData({ ...formData, Name: value })}
                  required
                  className={error === messages['fleetLandmark_error_name'] ? 'errorInputImport' : ''}
                />
              </Grid>

              <Grid item xs={12} style={{ marginTop: 10 }}>
                <label className="input-normal-label">
                  {messages['mapLandmarkCreateEditLandmark_address']} <span className="text-danger"> *</span>
                </label>
                <div style={{ marginTop: 10 }}>
                  <InputSearchMap
                    normalView
                    noMap
                    onGetAddress={(value) => {
                      if (value && value?.length) {
                        const address = value[0];
                        setFormData({ ...formData, address });
                      }
                    }}
                    onClear={() => {
                    }}
                    draggable={false}
                    searchValueMap={valueMap}
                    className={error === messages['mapLandmarkImport_errorAddress'] ? 'errorInputImport' : ''}
                    noOptionsText={messages['noOptions']}
                    placeholder={messages['search']}
                  />
                </div>

              </Grid>

              <Grid item xs={12}>
                <Input
                  id="name"
                  type="text"
                  label={messages['mapLandmarkCreateEditLandmark_radius']}
                  placeholder={messages['mapLandmarkCreateEditLandmark_radius']}
                  value={formData.Radius}
                  onChange={(value) => setFormData({ ...formData, Radius: value })}
                  required
                  className={error === messages['mapLandmarkImport_errorRadius'] ? 'errorInputImport' : ''}
                />
              </Grid>

              <Grid item xs={12} style={{ marginTop: 10 }}>
                {/* <TagFilter
                  id="tags"
                  label={messages["vehicleView_tags"]}
                  placeholder={messages["vehicleView_tags"]}
                  values={formData?.Tags || []}
                  multiple={true}
                  required
                  requiredMessage={messages['required_field']}
                  className={error === messages['mapLandmarkImport_errorTag'] ? 'errorInputImport' : ''}
                  onChange={(items) => {

                    setFormData({ ...formData, Tags: items })
                  }}
                /> */}
              </Grid>
            </Grid>
          </Form>
        </div>
      </ModalBody>
      <ModalFooter style={{ bottom: 50, textAlign: 'right' }}>
        <Button
          onClick={handleClose}
          className="btn-cancel"
          disabled={loadingResponse}
        >
          {messages['cancel']}
        </Button>

        <Button
          disabled={loadingResponse}
          onClick={(e) => {
            if (e) e.preventDefault();
            editCreateLandmark.current.submit();

          }}
          className="btn-blue"
        >
          {messages['save']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default LandmarkImportEdit;